module.exports = __webpack_public_path__ + "media/notification-ring.51377e11.mp3";